import * as Types from 'src/state/gql/_types';
import { AsyncAction } from 'src/state/_types';
import { handleGraphqQLErrorResponse } from 'src/state/gql/utils';

export const createItems: AsyncAction<Types.CreateDocumentsMutationVariables,Types.CreateDocumentsMutation['items']> = async ({state, effects}, payload) => {
    state.bookings.errors = [];
    try {
        let { items } = await effects.gql.mutations.CreateDocuments(payload);
        return items;
    } catch (e: any) {
        state.bookings.errors = handleGraphqQLErrorResponse(e);
        return null;
    }
}